import { define } from 'hooked-elements'
import textBalancer from 'text-balancer'
textBalancer.balanceText('[data-component~="balancer"]')